// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2g59G","signatureButtonsRight":"ModalSign_signatureButtonsRight__1Ti3P"};